const datasetCollectionActions = {
  ADD_DATASET_COLLECTIONS: 'ADD_DATASET_COLLECTIONS',
  ADD_DATASET_COLLECTIONS_ASSIGNABLE: 'ADD_DATASET_COLLECTIONS_ASSIGNABLE',
  ADD_DATASET_COLLECTIONS_ERROR: 'ADD_DATASET_COLLECTIONS_ERROR',
  ADD_DATASET_COLLECTIONS_SUCCESS: 'ADD_DATASET_COLLECTIONS_SUCCESS',
  FETCH_DATASET_COLLECTIONS: 'FETCH_DATASET_COLLECTIONS',
  FETCH_DATASET_COLLECTIONS_ASSIGNABLE: 'FETCH_DATASET_COLLECTIONS_ASSIGNABLE',
  FETCH_DATASET_COLLECTIONS_ASSIGNABLE_ERROR: 'FETCH_DATASET_COLLECTIONS_ASSIGNABLE_ERROR',
  FETCH_DATASET_COLLECTIONS_ASSIGNABLE_SUCCESS: 'FETCH_DATASET_COLLECTIONS_ASSIGNABLE_SUCCESS',
  HIDE_ADD_DATASET_COLLECTIONS: 'HIDE_ADD_DATASET_COLLECTIONS',
  HIDE_REMOVE_DATASET_COLLECTION_CONFIRMATION: 'HIDE_REMOVE_DATASET_COLLECTION_CONFIRMATION',
  REMOVE_DATASET_COLLECTION: 'REMOVE_DATASET_COLLECTION',
  REMOVE_DATASET_COLLECTION_ASSIGNABLE: 'REMOVE_DATASET_COLLECTION_ASSIGNABLE',
  REMOVE_DATASET_COLLECTION_ERROR: 'REMOVE_DATASET_COLLECTION_ERROR',
  REMOVE_DATASET_COLLECTION_SUCCESS: 'REMOVE_DATASET_COLLECTION_SUCCESS',
  SHOW_ADD_DATASET_COLLECTIONS: 'SHOW_ADD_DATASET_COLLECTIONS',
  SHOW_DATASET_COLLECTIONS: 'SHOW_DATASET_COLLECTIONS',
  SHOW_DATASET_COLLECTIONS_ERROR: 'SHOW_DATASET_COLLECTIONS_ERROR',
  SHOW_REMOVE_DATASET_COLLECTION_CONFIRMATION: 'SHOW_REMOVE_DATASET_COLLECTION_CONFIRMATION',
  UPDATE_DATASET_COLLECTIONS_ASSIGNABLE_PROPERTIES: 'UPDATE_DATASET_COLLECTIONS_ASSIGNABLE_PROPERTIES',
  UPDATE_DATASET_UNASSIGNED_COLLECTIONS_PROPERTIES: 'UPDATE_DATASET_UNASSIGNED_COLLECTIONS_PROPERTIES',
};

export default datasetCollectionActions;
